module.exports = __webpack_public_path__ + "static/media/shellWhite.f4f75693.png";